import { defineComponent, h, type Component } from 'vue';
import { Speaker } from 'lucide-vue-next';
import {
    ArrowPathIcon,
    ChartBarIcon,
    CircleStackIcon,
    Cog6ToothIcon,
    ExclamationTriangleIcon,
    HomeIcon,
    MusicalNoteIcon,
    NoSymbolIcon,
    ShieldCheckIcon,
    UserCircleIcon,
} from '@heroicons/vue/24/outline';
import PhosphorMusicNoteSimple from '@/assets/icons/stock/phosphor-music-note-simple.svg?component';
import TablerBuildingCommunity from '@/assets/icons/stock/tabler-building-community.svg?component';
import type { AreaId } from '@/navigation/areas';

/**
 * The Players area shows the same speaker as the Player record type. Lucide
 * draws at stroke 2; 1.5 matches the Heroicons outline beside it.
 */
const PlayersAreaIcon = defineComponent({ name: 'PlayersAreaIcon', render: () => h(Speaker, { strokeWidth: 1.5 }) });

/**
 * The icons for areas and pages, shared by the icon strip, the section sidebar
 * and the breadcrumb menus, so each place shows the same one.
 */

export const AREA_ICONS: Readonly<Record<AreaId, Component>> = {
    home: HomeIcon,
    clients: TablerBuildingCommunity,
    players: PlayersAreaIcon,
    // The same note as a live track. Copied from Phosphor (MIT), like Tabler's
    // building-community above; see modelIcons.ts.
    music: PhosphorMusicNoteSimple,
    reports: ChartBarIcon,
    settings: Cog6ToothIcon,
};

/**
 * Each page keeps the icon it had in the old sidebar, by route name, drawn from
 * the outline set like every other sidebar icon (Joel, 2026-10-24). They were
 * solid until then, so five of them looked heavier than the rows around them.
 */
export const PAGE_ICONS: Readonly<Record<string, Component>> = {
    'track-matching': ArrowPathIcon,
    'audio-file-issues': ExclamationTriangleIcon,
    'playlist-switching': MusicalNoteIcon,
    permissions: ShieldCheckIcon,
    'ddex-configurations': NoSymbolIcon,
    'dynamo-table-stats': CircleStackIcon,
    profile: UserCircleIcon,
};
